// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wny-boxplot .wny-label {\n  font-size: 8px;\n  fill: #aaa;\n}\n.wny-boxplot .wny-value {\n  font-size: 9px;\n  font-weight: bold;\n  fill: #333;\n  cursor: pointer;\n}\n.wny-boxplot .wny-value:hover {\n  fill: #f30;\n}\n", ""]);
// Exports
module.exports = exports;
